<ion-card>
    <ion-card-content (click)="display = !display;">
        <ion-label *ngIf="!display">Show Job Details...</ion-label>
        <ion-label *ngIf="display">Hide Job Details...</ion-label>
    </ion-card-content>
    <ion-card-content class="inner-content">
        <ion-grid *ngIf="display">
            <ion-row>
                <ion-col size="6" class="graytext ion-text-right">
                    Job Number:
                </ion-col>
                <ion-col size="6">
                    <b>{{ document.serviceJob.jobNumber }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="6" class="graytext ion-text-right">
                    Job Type:
                </ion-col>
                <ion-col size="6">
                    <b>{{ document.serviceJob.jobType }}</b>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="6" class="graytext ion-text-right">
                    Scheduled Date:
                </ion-col>
                <ion-col size="6">
                    <b>{{document.serviceJob.scheduledDate | date:'dd/MM/yyyy'}}</b>
                </ion-col>
            </ion-row>
            <ion-row *ngIf="document.serviceJob.engineer">
                <ion-col size="6" class="graytext ion-text-right">
                    Engineer:
                </ion-col>
                <ion-col size="6">
                    <b>{{document.serviceJob.engineer.name}}</b>
                </ion-col>
            </ion-row>
            <ion-row class="ion-text-center" *ngIf="document.serviceJob.servicedItem.pdesc">
                <ion-col size="12">
                    {{document.serviceJob.servicedItem.pdesc}}/{{document.serviceJob.servicedItem.reg}}<br>
                    {{document.serviceJob.servicedItem.description}}
                </ion-col>
            </ion-row>
            <ion-row class="ion-text-center" *ngIf="document.serviceJob.servicedItem.plu">
                <ion-col size="12">
                    {{document.serviceJob.servicedItem.plu}}
                    - {{document.serviceJob.servicedItem.comment ? document.serviceJob.servicedItem.comment : document.serviceJob.servicedItem.description}}
                    <br>
                    Serial: {{document.serviceJob.servicedItem.serial}}
                </ion-col>
            </ion-row>
            <ion-row *ngIf="document.serviceJob.servicedItem.pdesc">
                <ion-col size="12">
                    <ion-button color="light" expand="full"
                                (click)="fetchLegacyJobs(document.serviceJob.servicedItem.plantOrProductId)"
                                shape="round">
                        View Plant History
                    </ion-button>
                </ion-col>
            </ion-row>
            <ion-item lines="none">
                <ion-label position="floating">Job Status</ion-label>
                <ion-select [(ngModel)]="currentJobStatus" interface="popover" (ionChange)="updateJobStatus($event)">
                    <ion-select-option [value]="jobStatus.id"
                                       *ngFor="let jobStatus of jobStatusList">{{jobStatus.description}}</ion-select-option>
                </ion-select>
            </ion-item>
        </ion-grid>
    </ion-card-content>
</ion-card>
